/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_HomeInputs */

const en_gc_guides_home = /** @type {(inputs: Gc_Guides_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const zh_gc_guides_home = /** @type {(inputs: Gc_Guides_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Gc_Guides_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_home = /** @type {((inputs?: Gc_Guides_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_home(inputs)
	return zh_gc_guides_home(inputs)
});
export { gc_guides_home as "gc.guides.home" }